import { render } from "./Pruebas-Tecnicas.vue?vue&type=template&id=878f6168"
import script from "@/layouts/Examen/Pruebas-Tecnicas?vue&type=script&lang=js"
export * from "@/layouts/Examen/Pruebas-Tecnicas?vue&type=script&lang=js"

import "./Pruebas-Tecnicas.vue?vue&type=style&index=0&id=878f6168&lang=scss"

import exportComponent from "C:\\Users\\elkinc\\Desktop\\ANSV\\Licencias\\AppExamenes\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__